document.addEventListener("DOMContentLoaded", function () {
  /**
   * Quick booking panel
   */
  const elemRange = document.querySelector(".voyager-booking-panel");
  if (typeof elemRange != "undefined" && elemRange != null) {
    /**
     * Create the date picker with default params
     */
    const voyagerToday = new Date();
    const dateOptionsRange = {
      maxView: 1,
      minDate: voyagerToday, // no dates available before today
      autohide: true,
      todayHighlight: true,
      format: "yyyy-mm-dd",
      allowOneSidedRange: true,
      nextArrow: "",
      prevArrow: "",
      toggle: true, // new option added
    };
    const datepickerRange = new DateRangePicker(elemRange, dateOptionsRange);
    const monthStyle = elemRange.getAttribute("data-month-style");

    let isNavigateToNextEnabled = false;

    /**
     * Update the date picker with selected dates when the page is refreshed or revisited
     * See ./templates/voyager-booking-panel.php for setCookie() + setValues()
     */
    function getCookie(cookie_name) {
      let name = cookie_name + "=";
      let cookies = document.cookie.split(";");

      for (let cookie_count = 0; cookie_count < cookies.length; cookie_count++) {
        let cookie_data = cookies[cookie_count];
        while (cookie_data.charAt(0) == " ") {
          cookie_data = cookie_data.substring(1);
        }
        if (cookie_data.indexOf(name) == 0) {
          return cookie_data.substring(name.length, cookie_data.length);
        }
      }
      return "";
    }

    /**
     * Buid the date cards the the day and the month respectively
     * @param {*} type - date card ID (id="checkin" && id="checkout")
     * @param {*} date
     */
    function buildDateCard(type, date) {
      //  Get the date "again"
      const newCardDate = new Date(date);

      // If we need to translate the days...
      // const formatter = new Intl.DateTimeFormat('fr', { month: 'long' });
      // const month1 = formatter.format(new Date());

      // Convert the dates to local strings days (03) and months (January)
      const newCardDay = newCardDate.toLocaleString("default", { day: "2-digit" });
      const newCardMonth = newCardDate.toLocaleString("default", { month: monthStyle ? monthStyle : "short" });

      // Find our date card elements from the "type"
      let day = document.getElementById(type).querySelector(".voyager-booking-panel__card-day");
      let month = document.getElementById(type).querySelector(".voyager-booking-panel__card-month");

      // Add out new day and month names
      day.innerHTML = newCardDay;
      month.innerHTML = newCardMonth;
    }

    /**
     * Update the date elements when the date is changed on the picker
     */
    let hub_input = document.querySelectorAll(".voyager-booking-panel__card-input");
    for (let hub_item = 0; hub_item < hub_input.length; hub_item++) {
      hub_input[hub_item].addEventListener("show", function (evt) {
        // Update date elements if there have date range picker
        if (
          !!hub_input[hub_item].datepicker.rangepicker &&
          hub_input[hub_item].datepicker.rangepicker.inputs.length > 1
        ) {
          // Disable dates up to start date while show the end date picker
          let { inputs } = evt.detail.datepicker.rangepicker,
            dateRangeStartDate = inputs[0],
            dateRangeEndDate = inputs[1];

          if (evt.target == dateRangeStartDate) {
            datepickerRange.setOptions({ minDate: dateOptionsRange.minDate });
          }

          if (evt.target == dateRangeEndDate) {
            let startDate = datepickerRange.getDates(dateOptionsRange.format)[0];
            datepickerRange.setOptions({ minDate: startDate });
          }
        }
      });

      hub_input[hub_item].addEventListener("changeDate", function (evt) {
        // Update date elements if there have date range picker
        if (
          !!hub_input[hub_item].datepicker.rangepicker &&
          hub_input[hub_item].datepicker.rangepicker.inputs.length > 1
        ) {
          hub_input[hub_item].datepicker.rangepicker.inputs.forEach((input) => {
            // Update date elements
            let rangeInputDate = new Date(input.datepicker.dates[0]);
            buildDateCard(input.parentElement.id, rangeInputDate);
          });

          // Return to the first load when the date changes from the cookies
          if (!isNavigateToNextEnabled) return false;

          // date range picker Quick navigate to end date
          let { inputs } = evt.detail.datepicker.rangepicker,
            dateRangeStartDate = inputs[0],
            dateRangeEndDate = inputs[1];

          if (evt.target == dateRangeStartDate) {
            setTimeout(() => {
              dateRangeEndDate.datepicker.show();
              evt.detail.datepicker.picker.prevElement = null;
            }, 50);
          }

          // focus on the next element(submit button) after selecting the end date
          let closestSiblingSelector = dateRangeEndDate.closest("#checkout-field");
          if (evt.target == dateRangeEndDate && !!closestSiblingSelector) {
            closestSiblingSelector.nextElementSibling &&
              setTimeout(() => {
                closestSiblingSelector.nextElementSibling.focus();
                evt.detail.datepicker.picker.prevElement = null;
              }, 50);
          }
        } else {
          buildDateCard(hub_input[hub_item].parentElement.id, evt.detail.date);
        }
      });
    }

    /**
     * Check the cookie for the booking date
     */
    let quickbook = getCookie("voyager_quickbook");
    if (quickbook != "") {
      // Parse the cookies string as an object
      let quickbook_object = JSON.parse(quickbook);
      // Set the dates stored in the cookie
      datepickerRange.setDates(quickbook_object.checkin, quickbook_object.checkout);

      buildDateCard("checkin-field", quickbook_object.checkin);
      buildDateCard("checkout-field", quickbook_object.checkout);
      // alert("checking date: " + quickbook_object.checkin + " - " + quickbook_object.checkout);
    } else {
      // If no cookie is set for the datepickers...
      // Set the checkin date card to today date
      const todaysDate = new Date();
      buildDateCard("checkin-field", todaysDate);
      // Set the checkout date card to tomorrow
      let tomorrowsDate = new Date();
      tomorrowsDate.setDate(todaysDate.getDate() + 1);
      buildDateCard("checkout-field", tomorrowsDate);
      // Set the datepicker dates for today and tomorrow
      // console.log(todaysDate);
      // console.log(tomorrowsDate);
      datepickerRange.setDates(todaysDate, tomorrowsDate);
    }

    // Enable navigate to the next element functionality after the date set from the cookies(Navigate to Next will work in the date change event)
    isNavigateToNextEnabled = true;
  }
});
